import { leads } from './leads'
import { stock } from './stock'

const forwarder = {
  forwarder_leads: leads,
  forwarder_stock: stock,
}
export default forwarder
